
import {from as observableFrom,  Observable } from "rxjs";

import { Location } from "@angular/common";
import { AfterViewInit, Directive } from "@angular/core";
import { filter, take } from "rxjs/operators";
import { CommonFormManagerDirective } from "../form-manager.directive";

@Directive({
    selector: "[navBackOnFormClose]",
    exportAs: "NavBackOnFormClose",
})
export class NavBackOnFormCloseDirective implements AfterViewInit {
    constructor(
        public locationRef: Location,
        public formManager: CommonFormManagerDirective,
    ) { }

    public ngAfterViewInit() {
        observableFrom(this.formManager.formClose$).pipe(
            filter((closed) => !!closed),
            take(1))
            .subscribe(() => {
                this.locationRef.back();
            });
    }
}
